class ClickAndMixBundle extends HTMLElement {
  constructor() {
    super();
    this.selpack = [];
    var this2 = this;
    $(document).ready(function () {
      this2.init();
    });
  }

  init() {
    var this2 = this;
    // if (window.matchMedia("(max-width: 1023px)").matches) {
    //   $(".selected-packs").prependTo(".click-and-mix-wrapper");
    //   //$(".orginal-product-form").appendTo(".clicknmix-desktop");
    //   $(".click-and-mix-section").removeClass("section--divider");
    //   $(".selected-packs").addClass("section--divider");
    //   $(".selected-packs").addClass("animate");
    //   window.onscroll = function () {
    //     onScrollHeader();
    //   };

    //   function onScrollHeader() {
    //     if (
    //       document.body.scrollTop > 0 ||
    //       document.documentElement.scrollTop > 0
    //     ) {
    //       if (
    //         $(".shopify-section-group-header-group").hasClass(
    //           "shopify-section-header-hidden"
    //         )
    //       ) {
    //         $(".selected-packs").css("top", "0px");
    //       } else {
    //         $(".selected-packs").css("top", "46px");
    //       }
    //     }
    //     if (
    //       document.body.scrollTop > 0 ||
    //       document.documentElement.scrollTop > 0
    //     ) {
    //       if ($(".selected-packs h2").is(":visible") == true) {
    //         $(".selected-packs h2").slideUp(100);
    //       }
    //     } else {
    //       if ($(".selected-packs h2").is(":visible") == false) {
    //         $(".selected-packs h2").slideDown(100);
    //       }
    //     }
    //   }
    // }
    // Function to initialize logic based on viewport width
    function initializeSelectedPacks() {
      if (window.matchMedia("(max-width: 1023px)").matches) {
        $(".selected-packs").prependTo(".click-and-mix-wrapper");
        //$(".orginal-product-form").appendTo(".clicknmix-desktop");
        $(".click-and-mix-section").removeClass("section--divider");
        $(".selected-packs").addClass("section--divider");
        $(".selected-packs").addClass("animate");

        window.onscroll = function () {
          onScrollHeader();
        };

        function onScrollHeader() {
          if (
            document.body.scrollTop > 0 ||
            document.documentElement.scrollTop > 0
          ) {
            if (
              $(".shopify-section-group-header-group").hasClass(
                "shopify-section-header-hidden"
              )
            ) {
              $(".selected-packs").css("top", "0px");
            } else {
              $(".selected-packs").css("top", "46px");
            }
          }
          if (
            document.body.scrollTop > 0 ||
            document.documentElement.scrollTop > 0
          ) {
            if ($(".selected-packs h2").is(":visible") == true) {
              $(".selected-packs h2").slideUp(100);
            }
          } else {
            if ($(".selected-packs h2").is(":visible") == false) {
              $(".selected-packs h2").slideDown(100);
            }
          }
        }
      } else {
        // Code for desktop view or other viewport conditions
        $(".selected-packs").appendTo(".clicknmix-desktop .click-and-mix-left"); // Move selected-packs

        $(".clicknmix-desktop .click-and-mix-left")
          .find("performance-popup") // Locate performance-popup
          .after($(".selected-packs"));
        $(".click-and-mix-section").addClass("section--divider");
        $(".selected-packs").removeClass("section--divider animate");
        $(".selected-packs").css("top", ""); // Reset styles
        $(".selected-packs h2").show(); // Ensure header is visible

        // Remove scroll event if previously added
        window.onscroll = null;
      }
    }

    // Initialize logic on page load
    initializeSelectedPacks();

    // Reinitialize logic on viewport change
    $(window).on("resize", function () {
      // Optional: Reload the page to reset the layout completely
      // location.reload();

      // Alternatively, you can reinitialize without reloading the page
      initializeSelectedPacks();
    });

    if (localStorage.hasOwnProperty("selpack")) {
      this.selpack = JSON.parse(localStorage.getItem("selpack"));
    }

    var packsize =
      localStorage.getItem("packsize") ||
      $(".choose-options .choose-item.active").data("size");

    if (packsize) {
      $(".choose-options .choose-item").removeClass("active");
      $(
        '.variant-input-wrapper input[name="Pack"][value="' +
          packsize +
          '-Pack"]'
      ).click();

      $(".choose-options .choose-item[data-size='" + packsize + "']").addClass(
        "active"
      );
      $(".selected-packs").attr("data-packsize", packsize);

      if (packsize == 20) {
        $(".selected-packs")
          .find(".inner-text")
          .html(10 + "-PACK");
      } else {
        $(".selected-packs")
          .find(".inner-text")
          .html(packsize + "-PACK");
      }
      $(".selected-items-wrapper").find(".selected-item").removeClass("active");
      $(".selected-qty").html("0");
      $(".product-selector-item").removeClass("active");

      for (let index = 0; index < this2.selpack.length; index++) {
        var job = this2.selpack[index];
        $('.selected-qty[data-varid="' + job["id"] + '"]')
          .parents(".product-selector-item")
          .addClass("active");
        $('.selected-qty[data-varid="' + job["id"] + '"]').html(
          Number(job["qty"])
        );
      }
      $(
        '.variant-input-wrapper input[name="Pack"][value="' +
          packsize +
          '-Pack"]'
      ).click();

      reloadsectiondata();
    }

    $(".choose-options .choose-item").click(function () {
      $(".choose-options .choose-item").removeClass("active");
      $(this).addClass("active");
      $(".selected-packs").attr("data-packsize", $(this).data("size"));
      var packsize = $(this).data("size");
      $(
        '.variant-input-wrapper input[name="Pack"][value="' +
          $(this).data("size") +
          '-Pack"]'
      ).click();
      if ($(this).data("size") == 20) {
        $(".selected-packs")
          .find(".inner-text")
          .html(10 + "-PACK");
      } else {
        $(".selected-packs")
          .find(".inner-text")
          .html($(this).data("size") + "-PACK");
      }
      $(".selected-items-wrapper").find(".selected-item").removeClass("active");
      $(".selected-qty").html("0");
      $(".product-selector-item").removeClass("active");

      for (let index = 0; index < this2.selpack.length; index++) {
        var job = this2.selpack[index];
        $('.selected-qty[data-varid="' + job["id"] + '"]')
          .parents(".product-selector-item")
          .addClass("active");
        $('.selected-qty[data-varid="' + job["id"] + '"]').html(
          Number(job["qty"])
        );
      }
      var totalcount = 0;

      $(".selected-qty").each(function (index) {
        var value = Number($(this).html());
        if (value > 0) {
          var curcount = 0;
          for (let index = 1; index <= value; index++) {
            if (packsize == 5) {
              if (totalcount < 5) {
                totalcount = totalcount + 1;
                curcount = curcount + 1;
              } else {
                $(this).html(curcount);
                if (curcount == 0) {
                  $(this)
                    .parents(".product-selector-item")
                    .removeClass("active");
                }
              }
            }
            if (packsize == 10) {
              if (totalcount < 10) {
                totalcount = totalcount + 1;
                curcount = curcount + 1;
              } else {
                $(this).html(curcount);
                if (curcount == 0) {
                  $(this)
                    .parents(".product-selector-item")
                    .removeClass("active");
                }
              }
            }
          }
        }
      });

      reloadsectiondata();
    });

    $(".product-selector-item__add-trigger").click(function () {
      $(this).parents(".product-selector-item").find(".qty-add").click();
    });

    $(".addsingle").click(function () {
      $(this).parents(".product-selector-item").addClass("active");
      $(this).parents(".product-selector-item").find(".selected-qty").html("1");
      reloadsectiondata();
    });
    $(".image-wrapper").click(function () {
      var qty = Number(
        $(this).parents(".product-selector-item").find(".selected-qty").html()
      );
      $(this).parents(".product-selector-item").addClass("active");
      $(this)
        .parents(".product-selector-item")
        .find(".selected-qty")
        .html(qty + 1);
      reloadsectiondata();
    });
    $(".qty-minus").click(function () {
      var qty = Number(
        $(this).parents(".product-selector-item").find(".selected-qty").html()
      );
      if (qty == 1) {
        $(this).parents(".product-selector-item").removeClass("active");
        $(this)
          .parents(".product-selector-item")
          .find(".selected-qty")
          .html("0");
      } else {
        $(this)
          .parents(".product-selector-item")
          .find(".selected-qty")
          .html(qty - 1);
      }
      reloadsectiondata();
    });
    $(".qty-add").click(function () {
      var qty = Number(
        $(this).parents(".product-selector-item").find(".selected-qty").html()
      );
      $(this)
        .parents(".product-selector-item")
        .find(".selected-qty")
        .html(qty + 1);
      reloadsectiondata();
    });
    $(".selected-item").click(function () {
      if ($(this).hasClass("active")) {
        var index = $(this).attr("data-index");
        //console.log(index);
        $(this)
          .parents(".selected-item-box")
          .find('.remove-item[data-index="' + index + '"]')
          .click();
      }
    });
    $(".remove-item").click(function () {
      $(this).removeClass("active");
      var qty = Number(
        $(".selected-qty[data-varid='" + $(this).attr("data-varid") + "']")
          .parents(".product-selector-item")
          .find(".selected-qty")
          .html()
      );
      if (qty == 1) {
        $(".selected-qty[data-varid='" + $(this).attr("data-varid") + "']")
          .parents(".product-selector-item")
          .removeClass("active");
        $(".selected-qty[data-varid='" + $(this).attr("data-varid") + "']")
          .parents(".product-selector-item")
          .find(".selected-qty")
          .html("0");
      } else {
        $(".selected-qty[data-varid='" + $(this).attr("data-varid") + "']")
          .parents(".product-selector-item")
          .find(".selected-qty")
          .html(qty - 1);
      }
      $(this).removeAttr("data-varid");
      reloadsectiondata();
    });

    function reloadsectiondata() {
      //console.log($(".choose-item.active").data("size") + " ddd");
      $(".error-msg-bundle").remove();
      $(".selected-items-wrapper").find(".selected-item").removeClass("active");
      $(".remove-item-wrapper").find(".remove-item").removeClass("active");
      $(".remove-item-wrapper").find(".remove-item").removeAttr("data-varid");
      $(".selected-count").find("h1").html("0 / 5");

      var totalcount = 0;
      var aradded = [];

      $(".selected-qty").each(function (index) {
        var value = Number($(this).html());
        if (value > 0) {
          var job = {};
          job["id"] = $(this).data("varid");
          job["qty"] = value;
          aradded.push(job);

          for (let index = 1; index <= value; index++) {
            var ind = totalcount + 1;
            $('.selected-item[data-index="' + ind + '"]').addClass("active");
            $('.remove-item[data-index="' + ind + '"]').addClass("active");
            $('.selected-item[data-index="' + ind + '"]')
              .find("img")
              .attr(
                "src",
                $(this)
                  .parents(".product-selector-item")
                  .find(".item-img")
                  .attr("src")
              );
            $('.remove-item[data-index="' + ind + '"]').attr(
              "data-varid",
              $(this).data("varid")
            );
            totalcount = totalcount + 1;
          }
        }
      });

      if (totalcount > 5) {
        if (
          $(".choose-item.active").data("size") != "10" &&
          $(".choose-item.active").data("size") != "20"
        ) {
          $(".choose-item").removeClass("active");
          $('.choose-item[data-size="10"]').addClass("active");
          $(".selected-packs").attr("data-packsize", "10");
        }
      }
      if (totalcount > 10) {
        if ($(".choose-item.active").data("size") != "20") {
          $(".choose-item").removeClass("active");
          $('.choose-item[data-size="20"]').addClass("active");
          $(".selected-packs").attr("data-packsize", "20");
        }
      }

      if ($(".choose-item.active").data("size") == "20") {
        var wrapper = $(".selected-packs-wrapper").get(0);
        wrapper.scrollTo({
          left: totalcount >= 10 ? wrapper.scrollWidth : 0,
          behavior: "smooth",
        });
      }

      this2.selpack = [];
      this2.selpack = aradded;
      localStorage.setItem("selpack", JSON.stringify(this2.selpack));

      if (totalcount > 10) {
        $(".remove-box-2").css("display", "flex");
      } else {
        $(".remove-box-2").css("display", "none");
      }

      if ($(".choose-item.active").data("size") == "5") {
        $('.variant-input-wrapper input[name="Pack"][value="5-Pack"]').click();
        if (totalcount > 0) {
          $(".remove-box-1").css("display", "flex");
        } else {
          $(".remove-box-1").css("display", "none");
        }
        $(".selected-count h1").html(totalcount + " / 5");
        $(".product-selector-item")
          .find(".addsingle")
          .css("pointer-events", "auto");
        $(".qty-add").css("pointer-events", "auto");
        $(".image-wrapper").css("pointer-events", "auto");

        if (totalcount >= 5) {
          $("click-and-mix-bundle .product-form__submit").removeAttr(
            "disabled"
          );
          $("click-and-mix-bundle .checkout-btn").removeAttr("disabled");
        } else {
          $("click-and-mix-bundle .product-form__submit").attr(
            "disabled",
            true
          );
          $("click-and-mix-bundle .checkout-btn").attr("disabled", true);
        }
      }
      if ($(".choose-item.active").data("size") == "10") {
        $('.variant-input-wrapper input[name="Pack"][value="10-Pack"]').click();
        if (totalcount > 0) {
          $(".remove-box-1").css("display", "flex");
        } else {
          $(".remove-box-1").css("display", "none");
        }
        $(".product-selector-item")
          .find(".addsingle")
          .css("pointer-events", "auto");
        $(".qty-add").css("pointer-events", "auto");
        $(".image-wrapper").css("pointer-events", "auto");

        $(".selected-count h1").html(totalcount + " / 10");
        if (totalcount >= 10) {
          $("click-and-mix-bundle .product-form__submit").removeAttr(
            "disabled"
          );
          $("click-and-mix-bundle .checkout-btn").removeAttr("disabled");
        } else {
          $("click-and-mix-bundle .product-form__submit").attr(
            "disabled",
            true
          );
          $("click-and-mix-bundle .checkout-btn").attr("disabled", true);
        }
      }
      if ($(".choose-item.active").data("size") == "20") {
        $('.variant-input-wrapper input[name="Pack"][value="20-Pack"]').click();
        if (totalcount > 0) {
          $(".remove-box-1").css("display", "flex");
        } else {
          $(".remove-box-1").css("display", "none");
        }

        $(".selected-count h1").html(totalcount + " / 20");
        this2.twentypack = [];
        this2.twentypack = aradded;
        localStorage.setItem("twentypack", JSON.stringify(this2.twentypack));
        if (totalcount >= 20) {
          $(".product-selector-item:not(.active)")
            .find(".addsingle")
            .css("pointer-events", "none");

          $(".qty-add").css("pointer-events", "none");
          $(".image-wrapper").css("pointer-events", "none");
          $("click-and-mix-bundle .product-form__submit").removeAttr(
            "disabled"
          );
          $("click-and-mix-bundle .checkout-btn").removeAttr("disabled");
        } else {
          $(".product-selector-item")
            .find(".addsingle")
            .css("pointer-events", "auto");
          $(".qty-add").css("pointer-events", "auto");
          $(".image-wrapper").css("pointer-events", "auto");

          $("click-and-mix-bundle .product-form__submit").attr(
            "disabled",
            true
          );
          $("click-and-mix-bundle .checkout-btn").attr("disabled", true);
        }
      }

      $(".product-selector-item__add-trigger").css(
        "pointer-events",
        totalcount < 20 ? "auto" : "none"
      );

      localStorage.setItem("packsize", $(".choose-item.active").data("size"));
    }

    $(".checkout-btn").click(function (e) {
      e.preventDefault();
      e.stopPropagation();
      var id = $(this)
        .parents("product-form-clicknmix")
        .find('input[name="id"]')
        .val();
      var qty = 1;

      if ($(".rc-radio__input:checked").val() == "subscription") {
        var selid = $(this)
          .parents("product-form-clicknmix")
          .find(".input-sellingplan:checked")
          .val();
        var cartlink = `/cart/clear?return_to=/cart/add?items[][id]=${id}%26items[][quantity]=${qty}%26items[][selling_plan]=${selid}%26return_to=/checkout`;
        window.location.href = cartlink;
      } else {
        window.location.href = "/cart/" + id + ":" + qty;
      }
    });

    $(".rc-radio .rc-radio__input").change(function () {
      $(".rc-radio").removeClass("active");

      if ($(this).val() == "onetime") {
        $(".onetime-radio").addClass("active");
        $(".rc-widget .input-sellingplan").attr("disabled", true);
      } else {
        $(".subscription-radio").addClass("active");
        $(".rc-widget .input-sellingplan").removeAttr("disabled");
      }
    });
  }
}
customElements.define("click-and-mix-bundle", ClickAndMixBundle);
